import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { EffectiveRole, ROLE_META } from "@/lib/team-roles";

interface RoleBadgeProps {
  role: EffectiveRole;
  className?: string;
}

export const RoleBadge = ({ role, className }: RoleBadgeProps) => {
  const meta = ROLE_META[role] ?? ROLE_META.viewer;
  return (
    <Badge
      variant="outline"
      className={cn("border font-medium", meta.badgeClass, className)}
      title={meta.description}
    >
      {meta.label}
    </Badge>
  );
};

export default RoleBadge;
